//#region Libraries
import { useEffect, useState } from "react";
//#endregion
//#region Services
import { requestGetAcadReinforceById } from "services/acadReinforce/aboutAcadReinforce";
import { INITIAL_STATE } from "views/RefuerzoAcademico/components/FormCreateAcadReinforce/ManualLoadingForm/utils/reducer/acadReinforce.reducer";
import { requestGetCourseNameById } from "services/general";
import { acadReinforcementSessionStorage } from "services/storage/acadReinforcement";
//#endregion

const useResumeData = ({
    loadingRequest, 
    dataRelatedToForm: {
        allCampusDetail,
    }, loadedDataRelatedToAcadReinforceForm, 
    setForm, toStep
}) => {
    //#region States
    const [acadReinforceResumeData, setAcadReinforceResumeData] = useState(null);
    //#endregion
    //#region Effects
    useEffect(() => {
        if (!acadReinforcementSessionStorage.acadReinforceId.get()) return;
        if (loadedDataRelatedToAcadReinforceForm && !acadReinforceResumeData)
            fillAcadReinforceResumeData();
    }, [loadedDataRelatedToAcadReinforceForm]);
    useEffect(() => {
        if (!acadReinforceResumeData || !setForm) return;
        fillForm();
    }, [acadReinforceResumeData]);
    //#endregion
    //#region Functions
    const fillForm = () => {
        const {
            acadReinforceTypeId,
            course, tutor, payGradeId, 
            quantityVacancy, publicLoad } = acadReinforceResumeData.step1;
        const { 
            title, description, 
            standOutAcadReinforce,
            duration, locationId,
            zoomInscriptionTypeId,
            place
        } = acadReinforceResumeData.step2;
        const { form } = INITIAL_STATE;
        const newForm = {
            step1: {
                part1: {
                    acadReinforceTypeId, course
                },
                part2: {
                    tutor, payGradeId
                },
                part3: {
                    quantityVacancy: quantityVacancy,
                    publicLoad: {
                        id: publicLoad.id,
                        students: publicLoad.students 
                            ? publicLoad.students 
                            : form.step2.part3.publicLoad.students,
                        list: publicLoad.list 
                            ? publicLoad.list 
                            : form.step2.part3.publicLoad.list
                    }
                }
            },
            step2: {
                part1: {
                    title,
                    description,
                    standOutAcadReinforce 
                },
                part2: { 
                    duration: { ...duration } 
                },
                part3: {
                    locationId: locationId ? locationId : 0, 
                    zoomInscriptionTypeId: zoomInscriptionTypeId ? zoomInscriptionTypeId : 0,
                    place: place 
                        ? {
                            ...place,
                            environmentFillingTypeId: (
                                place.environment ? 1 
                                : place.otherEnvironment ? 2 
                                : 1
                            ),
                            environmentTypeId: place.environmentTypeId || "",
                            environment: place.environment 
                                ? {
                                    id: place.environment.id,
                                    environmentCode: place.environment.environmentCode || "",
                                    address: place.environment.address || "",
                                    floor: place.environment.floor || "",
                                    capacity: place.environment.capacity || ""
                                }
                                : form.step2.part3.place.environment,
                            otherEnvironment: place.otherEnvironment 
                                ? place.otherEnvironment 
                                : form.step2.part3.place.otherEnvironment
                        }
                        : form.step2.part3.place
                }
            }
        };
        setForm(newForm);
        if (locationId > 0) {
            toStep(3);
            return;
        }
        if (acadReinforceTypeId > 0) 
            toStep(2);
    }
    const fillAcadReinforceResumeData = async () => {
        loadingRequest.show();
        const data = await requestGetAcadReinforceById(acadReinforcementSessionStorage.acadReinforceId.get());
        const newAcadReinforceResumeData = {
            step1: await getAcadReinforceResumeDataStep1(data),
            step2: getAcadReinforceResumeDataStep2(data)
        };
        loadingRequest.hide();
        setAcadReinforceResumeData(newAcadReinforceResumeData);
    }
    const getAcadReinforceResumeDataStep1 = async ({
        payGradeId, acadReinforceTypeId, course,
        tutor, quantityVacancy, publicLoad
    }) => {
        const { students, list } = INITIAL_STATE.form.step1.part3.publicLoad;
        return {
            acadReinforceTypeId,
            course: { 
                ...course,
                name: await requestGetCourseNameById(course.id)
            },
            tutor: {
                ...tutor,
                fullName: tutor.fullName || "-"
            },
            payGradeId,
            quantityVacancy,
            publicLoad: {
                id: publicLoad.students ? 1 :
                    publicLoad.list ? 2 
                    : 0,
                students: publicLoad.students ? publicLoad.students : students,
                list: publicLoad.list ? publicLoad.list : list,
            }
        };
    }
    const getAcadReinforceResumeDataStep2 = ({
        title, description, standOutAcadReinforce,
        zoomInscriptionTypeId, duration, locationId,
        place
    }) => {
        let step2 = {
            title: title || "", 
            description: description || "",
            standOutAcadReinforce: standOutAcadReinforce || false,
            duration: duration ? duration : INITIAL_STATE.form.step2.part2.duration,
            locationId: locationId || 0, 
            zoomInscriptionTypeId: zoomInscriptionTypeId || 0, 
            place: getPlaceFields(place)
        }
        return step2;
    }
    const getPlaceFields = place => {
        if (!place) return null;
        const {
            campusId, environmentTypeId, otherEnvironment, 
            installationId, environmentCode, 
            address, floor, capacity
        } = place;
        const foundCampusDetail = allCampusDetail.find(({ id }) => id === campusId);
        return {
            campus: {
                id: foundCampusDetail.id,
                name: foundCampusDetail.name
            },
            environmentTypeId,
            environment: installationId ? {
                id: installationId, environmentCode,
                address, floor, capacity
            } : null,
            otherEnvironment: otherEnvironment ? {
                envName: otherEnvironment,
                address, floor, capacity
            } : null
        };
    }
    //#endregion
    return {
        value: acadReinforceResumeData,
        fill: fillAcadReinforceResumeData
    };
}

export default useResumeData;